var map = {
	"./Stroke 1.png": 1177,
	"./Why Our Save the Dat.png": 1178,
	"./all_about_shipping@2x.png": 1179,
	"./ask_for_everything@2x.png": 1180,
	"./big-day@1x.png": 688,
	"./big-day@2x.png": 689,
	"./birds@1x.png": 1181,
	"./birds@2x.png": 1182,
	"./check-list@1x.png": 722,
	"./check-list@2x.png": 723,
	"./circle-better@1x.png": 1183,
	"./circle-better@2x.png": 1184,
	"./empty_rsvp.png": 1185,
	"./empty_rsvp2x.png": 1186,
	"./envelope.png": 724,
	"./envelope.svg": 1187,
	"./envelope@2x.png": 1188,
	"./events_doodle.png": 511,
	"./events_doodle.svg": 1189,
	"./gifts@1x.png": 1190,
	"./gifts@2x.png": 1191,
	"./guest-list@1x.png": 673,
	"./guest-list@2x.png": 674,
	"./guest.png": 1192,
	"./guest.svg": 1193,
	"./guest2x.png": 1194,
	"./guest_approved@2x.png": 1195,
	"./invitations@1x.png": 690,
	"./invitations@2x.png": 691,
	"./invites_paper.svg": 1196,
	"./invites_paper@1x.png": 725,
	"./invites_paper@2x.png": 726,
	"./laptop-one-heart.png": 1197,
	"./laptop-one-heart@2x.png": 1198,
	"./laptop@1x.png": 1199,
	"./laptop@2x.png": 1200,
	"./long-page-checklist.png": 1201,
	"./long-page-checklist@2x.png": 1202,
	"./make_it_personal@2x.png": 1203,
	"./namecard-with-name.png": 1204,
	"./namecard-with-name@2x.png": 1205,
	"./namecard_no_name.svg": 512,
	"./namecard_with_name.svg": 1206,
	"./namecard_with_question_marks.svg": 222,
	"./no_address.png": 1207,
	"./no_address2x.png": 1208,
	"./onboarding_1.png": 1209,
	"./onboarding_1@2x.png": 1210,
	"./onboarding_2.png": 1211,
	"./onboarding_2@2x.png": 1212,
	"./onboarding_3.png": 1213,
	"./onboarding_3@2x.png": 1214,
	"./onboarding_4.png": 1215,
	"./onboarding_4@2x.png": 1216,
	"./red-star-left@1x.png": 675,
	"./red-star-left@2x.png": 676,
	"./red-star-right@1x.png": 677,
	"./red-star-right@2x.png": 678,
	"./registry_publish_champagne.svg": 1217,
	"./rsvp@1x.png": 692,
	"./rsvp@2x.png": 693,
	"./save-the-date@1x.png": 694,
	"./save-the-date@2x.png": 695,
	"./sparkle-left.svg": 679,
	"./sparkle-right.svg": 680,
	"./sparkle-up.svg": 727,
	"./ta-da.png": 1218,
	"./ta-da@2x.png": 1219,
	"./talk.svg": 1220,
	"./talk@1x.png": 696,
	"./talk@2x.png": 697,
	"./timeline-line-dark@1x.png": 698,
	"./timeline-line-dark@2x.png": 699,
	"./timeline-line@1x.png": 1221,
	"./timeline-line@2x.png": 1222,
	"./tips.svg": 1223,
	"./underline_long@1x.png": 661,
	"./underline_long@2x.png": 662,
	"./underline_sm@1x.png": 667,
	"./underline_sm@2x.png": 668,
	"./website_publish_confetti.svg": 513,
	"./wedding-websites@1x.png": 728,
	"./wedding-websites@2x.png": 729,
	"./wedding_help.png": 730,
	"./wedding_help.svg": 1224,
	"./wedding_help@2x.png": 1225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 327
// module chunks = 53